// «Такой страницы в пульте нет» (задача D4): путь не совпал ни с одним разделом.
import { MapPinOff } from 'lucide-react';
import { Link } from 'react-router';
import { buttonVariants } from '@/components/ui/button';
import { StateScreen } from './state-screen';

export function NotFound() {
  return (
    <StateScreen
      icon={MapPinOff}
      title="Такой страницы в пульте нет"
      action={
        <Link to="/readiness" className={buttonVariants({ size: 'lg' })}>
          Открыть «Готовность»
        </Link>
      }
    />
  );
}
